import React from 'react';
import 'components/styles/header.css';
import useSmallScreenSize from 'hooks/useSmallScreenSize';
// import usePartnerId from 'hooks/usePartnerId';
import { ReactComponent as Carrefour } from 'assets/images/carrefour.svg';
import { ReactComponent as CarrefourLogo } from 'assets/images/carrefour-logo.svg';
import { ReactComponent as MajidIcon } from 'assets/images/majid-icon.svg';
import { ReactComponent as HyperMaxLogo } from 'assets/images/hypermax-colored.svg';
import { ReactComponent as HyperMaxLogoSmall } from 'assets/images/hypermax-small-logo.svg';
import { HYPERMAX_COUNTRIES } from 'constants';
import PropTypes from 'prop-types';
import ResponsiveImage from 'components/responsive-image';


const Header = ({ partner }) => {
  const isSmallScreen = useSmallScreenSize();
  const isHyperMax = HYPERMAX_COUNTRIES.includes(partner?.countryOfOperation);
  const partnerLogoImages = partner?.images?.partnerLogo;
  const partnerLogo = partnerLogoImages?.desktop || partnerLogoImages?.mobile;
  
  const renderLogo = () => {
	  if (isHyperMax) {
      return isSmallScreen ? <HyperMaxLogoSmall className="hypermaxLogoSmall"/> : <HyperMaxLogo className="hypermaxLogo" />;
	  }
  
	  if (isSmallScreen) {
      return <MajidIcon />;
	  }
  
	  return (
      <div className="carrefourLogoHeader">
		  <CarrefourLogo />
		  <Carrefour />
      </div>
	  );
  };

  const renderPartnerLogo = () => {
    if (!partnerLogo) return null;
    return (
      <div className="partner-logo">
        <ResponsiveImage 
          images={partnerLogoImages}
          alt={partner?.partnerName} 
          className="partner-logo-image" 
        />
      </div>
    );
  };
  
  return (
	  <header>
      <div className={`nav ${partnerLogo ? 'nav-with-partner' : ''}`}>
		  <div className="logo">{renderLogo()}</div>
		  <div className={`headline ${partnerLogo ? 'headline-centered' : ''}`}>Partnership Portal</div>
		  {partnerLogo && renderPartnerLogo()}
      </div>
	  </header>
  );
};
  
Header.propTypes = {
  partner: PropTypes.object,
};

export default Header;
